import React from 'react'
import './NewFooter.css'
import {
    FaFacebookSquare,
    FaTwitterSquare,
    FaLinkedin,
    FaInstagram,
  } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function NewFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <div className='new-footer' id='footer-box'>
      <img src="/assets/Logo1.png" alt="" className='footer-logo' />
      <div className="footer-links-container">
        <div className="footer-links">
            <h3>About</h3>
            <Link to='/about'>
              <p>Company</p>
            </Link>
        </div>
        <div className="footer-links">
            <h3>Support</h3>
            <a href="https://intercom.help/pennytree/en">
            <p>FAQ</p>
            </a>
            <p>support@mypennytree.com</p>
            <p>+2349030266439</p>
            <p>+2349129782643</p>
            <p>27, Lagos Road,Epe,Lagos.</p>
        </div>
        <div className="footer-links">
            <h3>Legal</h3>
            <Link to='/policy'>
              <p>Terms of service</p>
            </Link>
        </div>
        <div className="footer-links">
            <h3>Follow us:</h3>
            <div className="social-icons">
          <a href="https://www.facebook.com/mypennytree" target='blank'>
            <FaFacebookSquare className="soc-icon" />
          </a>
          <a href="https://twitter.com/mypennytree?s=21&t=QiXq2XYZAHKDXmDZ7GH2Lw" target='blank'>
            <FaTwitterSquare className="soc-icon" />
          </a>
          <a href="https://www.linkedin.com/company/pennytree-services/" target='blank'>
            <FaLinkedin className="soc-icon" />
          </a>
          <a href="https://instagram.com/mypennytree?igshid=Zjc2ZTc4Nzk=" target='blank'>
            <FaInstagram className="soc-icon" />
          </a>

        </div>
        </div>
      </div>
      <div className="bottom-footer">
        <img src="/assets/merchant_logo.png" alt="" />
        <div className="app-icon-container" id='app-download'>
          <h3>Our Mobile app is available</h3>
        <div className="app-icons">
          <a href='https://play.google.com/store/apps/details?id=com.pennysafe.pennytree&hl=en_US&gl=US' target='blank'>
            <img src="/assets/play store.png" alt="" className='app-icon'/>
          </a>
          <a href='https://apps.apple.com/in/app/pennytree/id1602953102' target='blank'>
            <img src="/assets/App store.png" alt="" className='app-icon'/>
          </a>
        </div>
        </div>
        <img src="/assets/treegar.png" alt="" />
        <p>&copy; PennyTree {currentYear}</p>
      </div>
    </div>
  )
}

export default NewFooter
